import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const LanguagesComponent = lazy(
  () => import('./pages/languages/languages.tsx')
);

export const languagesRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <LanguagesComponent />
      </Suspense>
    )
  }
];
